import { handleWelcomeTour, updateUser } from "../../api/register";
import { toastr } from "react-redux-toastr";

export function RegisterationDone(payload) {
	return {
		type: 'REGISTER_DONE',
		payload,
	}
};

export function RegisterationStep1Done(payload) {
	return {
		type: 'STEP1_DONE',
		payload,
	}
};

export function RegisterationStep2Done(payload) {
	return {
		type: 'STEP2_DONE',
		payload,
	}
};

export function RegisterationStep3Done(payload) {
	return {
		type: 'STEP3_DONE',
		payload,
	}
};

export function RegisterationStep4Done(payload) {
	return {
		type: 'STEP4_DONE',
		payload,
	}
};

export function RegisterationStep4ActivateDone(payload) {
	return {
		type: 'STEP4_ACTIVATE_DONE',
		payload,
	}
};

export function RegisterationStep5Done(payload) {
	return {
		type: 'STEP5_DONE',
		payload,
	}
};


export function RegisterationStep6Done(payload) {
	return {
		type: 'STEP6_DONE',
		payload,
	}
};


export function EndWelcomTour(payload) {
	return {
		type: 'WELCOME_TOUR',
		payload,
	}
};

export function HandleFacebookLogin(payload) {
	return {
		type: 'FACEBOOK_LOGIN',
		payload,
	}
};

export function WelComeTourDone(payload) {
	return {
		type: 'WELCOME_TOUR_DONE'
	}
};

export function updateProfile(payload) {
	return {
		type: 'UPDATE_PROFILE_SUCCESS',
		payload,
	}
};


export const updateCurrentUserProfile = (data) => async dispatch => {
	try {
		const response = await updateUser(data);
		if (response.status == "success") {
			dispatch(updateProfile(response));
			toastr.success("Profile", "Successfully updated profile info.");
			window.location.href = "/profile";
		}
	} catch (e) {
		return [];
	}
};

export const UpdateWelcomeTour = () => async dispatch => {
	try {
		let response = await handleWelcomeTour();
		if (Object.keys(response).length) {
			dispatch(WelComeTourDone());
		}
	} catch (e) {
	}
};

